import {IReduxState} from '../'

/**
 * getState
 *
 * @param state - ReduxState
 */
export const getState = (state: IReduxState) => state.form
